module.exports = __webpack_public_path__ + "img/category_cover_Ideas.8bfd69f.webp";